<template>
  <div>
    <hint-widget hintName="statisticsVisits" type="text" btnMore></hint-widget>

    <statistics-filter
      v-if="filterParams.hotspotName"
      @filter="filterItems"
      :filters="['hotspot', 'range', 'periodVisits', 'typeVisits']"
      :default-params="filterParams"
      :loading="loading"
    ></statistics-filter>

    <v-alert type="error" :value="error">{{ error }}</v-alert>

    <statistics-chart
      @changeChartTypeDetail="changeChartTypeDetail"
      :chartdata="chartdata"
      :chartTypeDetailProp="filterParams.chartTypeDetail"
      class="mt-4"
      legend
    >
    </statistics-chart>
    <div class="layout">
      <div class="flex md8 xl9">
        <v-data-table
          v-model="selected"
          item-key="username"
          :headers="headers"
          :items="items"
          :total-items="pagination.totalItems"
          :pagination.sync="pagination"
          :rows-per-page-items="rowsPerPageItems"
          :loading="loading"
          sort-icon="icon icon-arrow-top ml-2"
          next-icon="icon icon-angle-right d-flex align-center"
          prev-icon="icon icon-angle-left d-flex align-center"
          :select-all="true"
          must-sort
        >
          <template v-slot:items="props">
            <tr
              :active="props.selected"
              @click="props.selected = !props.selected"
            >
              <td>
                <v-checkbox
                  :input-value="props.selected"
                  onIcon=""
                  offIcon=""
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.callingstationid }}</td>
              <td>{{ props.item.cnt }}</td>
              <td>{{ props.item.typeVisits }}</td>
              <td>{{ props.item.maxDate }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="flex md4 xl3 pt-5 mt-2 pl-3 ml-2">
        <sms-mailing
          :download="filterParams"
          :phoneSelected="phoneSelected"
          :countAllPhones="countAllPhones"
          type="statisticsVisit"
          @editSmsDialog="editSmsDialog"
        ></sms-mailing>
      </div>
    </div>
  </div>
</template>

<script>
import RequestApi from "../../modules/requestApi";
import Common from "../../modules/common";
import StatisticsFilter from "./StatisticsFilter.vue";
import StatisticsChart from "./StatisticsChart.vue";
import SmsMailing from "../sms/SmsMailing.vue";
import HintWidget from "../common/HintWidget";
import moment from "moment";
moment.locale("ru");

export default {
  name: "StatisticsVisits",

  components: {
    StatisticsChart,
    StatisticsFilter,
    SmsMailing,
    HintWidget
  },
  props: {
    // id хотспота
    hotspot_id: Number,
    // указывается для выбора по умолчанию
    hotspotName: String,
    // параметры для фильтра данных
    filterParams: {
      type: Object,
      // значения по умолчанию
      default: function() {
        return {
          // тип детализации графика
          chartTypeDetail: "day",
          hotspotName: "",
          range: {
            startDate: moment().subtract(1, "month"),
            endDate: new Date()
          },
          // частота посещений
          periodVisits: "day",
          // тип посещений
          typeVisits: null
        };
      }
    }
  },
  data: () => ({
    error: "",
    loading: false,
    // список выбранных строк checkbox-ми
    selected: [],
    // заголовки столбцов таблицы
    headers: [
      {
        text: "Телефон",
        sortable: true,
        value: "username"
      },
      {
        text: "MAC адрес",
        sortable: true,
        value: "callingstationid"
      },
      {
        text: "Количество авторизаций",
        sortable: true,
        value: "cnt"
      },
      {
        text: "Частота авторизаций",
        sortable: true,
        value: "typeVisits"
      },
      {
        text: "Последняя авторизация",
        sortable: true,
        value: "maxDate"
      }
    ],
    // данные таблицы
    items: [],
    // выбор к-ва строк на странице
    rowsPerPageItems: [10, 25, 50, 100],

    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 10,
      sortBy: "maxDate"
    },
    // данные графика
    chartdata: null
  }),

  computed: {
    //выбранные номера
    phoneSelected() {
      return new Set(this.selected.map(item => item.username));
    },
    // все номера
    countAllPhones() {
      return new Set(this.items.map(item => item.username)).size;
    }
  },

  mounted() {
    this.loading = true;
    // загружаем список хотспотов
    this.$store.dispatch("hotspotListLoad").then(() => {
      this.init();
    });
  },

  methods: {
    init() {
      if (this.hotspotName) {
        this.filterParams.hotspotName = this.hotspotName;
        this.filterParams.hotspot_id = this.hotspot_id;
      } else {
        this.filterParams.hotspotName = this.$store.getters.hotspotList[0].hotspot_name;
        this.filterParams.hotspot_id = this.$store.getters.hotspotList[0].id;
      }
      // передаем в StatisticsView текущие параметры фильтра для сохранения в шаблоны
      this.$emit("setFilter", this.filterParams);
      this.statChartData(this.filterParams);
    },

    /**
     * Срабатывает каждый раз по событиям pagination и sort данных
     * @param pagination
     */
    updatePagination(pagination) {
      // делаем запрос, когда подгрузилось к-во всех строк,
      // не была изменена сортировка либо при смене сортировки ждем когда переключится на 1 страницу
      if (
        this.pagination.totalItems &&
        (this.pagination.sortBy === pagination.sortBy ||
          (this.pagination.sortBy !== pagination.sortBy &&
            pagination.page === 1))
      ) {
        this.loading = true;
        Common.callLastInTime(() => {
          this.getList(pagination);
        }, 500);
      }
    },

    /**
     * Фильтрация данных
     */
    filterItems(params) {
      // передаем в StatisticsView текущие параметры фильтра для сохранения в шаблоны
      this.$emit("setFilter", params);
      this.pagination.page = 1;
      this.statChartData(params);
    },

    /**
     * Получение данных из базы
     */
    statChartData(filterParams) {
      this.loading = true;
      this.error = "";
      let labels = [];
      RequestApi.statVisitsChartData(filterParams)
        .then(data => {
          this.items = data.resultData;
          data = data.resultChart;

          // формируем labels
          if (filterParams.periodVisits === "day") {
            // уникальные ключи по дням
            labels = [
              ...new Set(
                data.often.map(
                  item => `${moment(item.minDate).format("DD.MM.YYYY")}`
                )
              )
            ];
          }
          if (filterParams.periodVisits === "week") {
            // уникальные ключи по неделям
            labels = [
              ...new Set(
                data.often.map(item => {
                  const startWeek = moment(item.minDate).startOf("isoWeek");
                  const endWeek = moment(startWeek).add(6, "days");

                  return `${moment(startWeek).format("DD.MM.YYYY")} - ${moment(
                    endWeek
                  ).format("DD.MM.YYYY")}`;
                })
              )
            ];
          }
          if (filterParams.periodVisits === "month") {
            // уникальные ключи по месяцам
            labels = [
              ...new Set(
                data.often.map(
                  item => `${moment(item.minDate).format("MMM YYYY")}`
                )
              )
            ];
          }
          if (filterParams.periodVisits === "quarter") {
            labels = [
              ...new Set(
                data.often.map(item => {
                  const startQuarter = moment(item.minDate).startOf("quarter");
                  const endQuarter = moment(startQuarter).add(3, "month");

                  return `${moment(startQuarter).format(
                    "DD.MM.YYYY"
                  )} - ${moment(endQuarter).format("DD.MM.YYYY")}`;
                })
              )
            ];
          }

          this.chartdata = {
            labels: labels,
            datasets: [
              {
                label: "Частые",
                backgroundColor: "#00CB9A",
                data: data.often.map(item => item.cnt)
              },
              {
                label: "Редкие",
                backgroundColor: "#FFD600",
                data: data.seldom.map(item => item.cnt)
              }
            ]
          };
          this.loading = false;
        })
        .catch(error => {
          this.error = error;
        });
    },

    /**
     * Менят тип детализации графика и
     * перезапускает отрисовку графика
     */
    changeChartTypeDetail(value) {
      this.filterParams.chartTypeDetail = value;
      this.statChartData(this.filterParams);
    },
    // отправка смс
    editSmsDialog(params) {
      this.$emit("editSmsDialog", params);
    }
  }
};
</script>
